export default [
    {
        path: "/patients",
        name: "patients",
        component: require("../components/modules/patient/PatientList.vue").default
    },
    {
        path: "/patients/new",
        name: "new patient",
        component: require("../components/modules/patient/PatientCard.vue").default
    },
    {
        path: "/patients/:id",
        name: "patient",
        component: require("../components/modules/patient/PatientCard.vue").default,
        props: true
    },
    {
        path: "/patients/:patient_id/examination/new",
        name: "new patient examination",
        component: require("../components/modules/patient/ExaminationCard.vue")
            .default,
        props: true
    },
    {
        path: "/patients/:patient_id/examination/:id",
        name: "patient examination",
        component: require("../components/modules/patient/ExaminationCard.vue")
            .default,
        props: true
    }
];
